import { createActionGroup, props } from "@ngrx/store";

import { CategorizationItem, Step } from "./step.state";

export const stepActions = createActionGroup({
  source: "Step",
  events: {
    "Find For Sample": props<{ sampleId: string }>(),
    "Find For Sample Success": props<{ steps: Step[], categories: Record<string, CategorizationItem> }>(),
    "Find For Sample Failure": props<{ error: string }>(),
  },
});
